import { render, staticRenderFns } from "./Usuario-add.vue?vue&type=template&id=22a25201"
import script from "./Usuario-add.vue?vue&type=script&lang=js"
export * from "./Usuario-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports